import { tsValidateArray, tsValidateDynamicObject, tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
import { DBDef_FHIRResource } from '../fhir-resource/index.js';
const Validator_GroupParamValue = {
    value: tsValidateString(),
    label: tsValidateString(undefined, false)
};
const Validator_ModifiableProps = {
    resourceId: tsValidateUniqueId,
    label: tsValidateString(),
    description: tsValidateString(undefined, false),
    groupParams: tsValidateDynamicObject(tsValidateArray(Validator_GroupParamValue), tsValidateString())
};
const Validator_GeneratedProps = {};
export const DBDef_FHIRResourceSubtype = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'fhir-resource-subtype',
    entityName: 'FHIR Resource Subtype',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'fhir-resource-subtype'
    },
    backend: {
        name: 'fhir-resource-subtype'
    },
    dependencies: {
        'resourceId': {
            dbKey: DBDef_FHIRResource.dbKey,
            fieldType: 'string',
        }
    }
};
//# sourceMappingURL=db-def.js.map